import { timeToMinutes } from 'src/helpers/timeToMinutes/timeToMinutes';
import { ITimetableDaySchedule } from './groupSchedulesByDay';

// end_time is inclusive of its final minute, so the next schedule touches it if it starts a minute later.
const isAdjacent = (previous: ITimetableDaySchedule, next: ITimetableDaySchedule): boolean =>
  timeToMinutes(next.startTime) === timeToMinutes(previous.endTime) + 1;

/**
 * Collapses runs of back-to-back invalid schedules (see getInvalidDefaultScheduleIds) into a single
 * tile - they all read "(!) No default menu/price scheme", so showing them separately just splits
 * one warning into several identical ones. Expects `items` sorted by start time, as
 * groupSchedulesByDay returns them. A merged item keeps its first schedule's id, which is itself
 * in `invalidScheduleIds`, so it still renders as invalid and keeps a stable React key.
 */
export const mergeAdjacentInvalidSchedules = (
  items: ITimetableDaySchedule[],
  invalidScheduleIds: Set<string>,
): ITimetableDaySchedule[] =>
  items.reduce<ITimetableDaySchedule[]>((merged, item) => {
    const previous = merged[merged.length - 1];

    if (
      previous &&
      invalidScheduleIds.has(previous.scheduleId) &&
      invalidScheduleIds.has(item.scheduleId) &&
      isAdjacent(previous, item)
    ) {
      merged[merged.length - 1] = {
        ...previous,
        endTime: item.endTime,
        dayPercent: previous.dayPercent + item.dayPercent,
        isDefault: previous.isDefault || item.isDefault,
      };
      return merged;
    }

    merged.push(item);
    return merged;
  }, []);
